import { AccountSearchInterface } from "../interface/searchInterface";

export const searchInit : AccountSearchInterface = {
    keywordType : '0',
    keyword : '',
    limit : 10,
    pageNo : 1,
    state: 'N',
    // 내부수정: 활성/비활성
    statusCodeList: ['N'],
}